import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

export function useSessionStorage(key: string) {
  const queryClient = useQueryClient();

  const q = useQuery({
    queryKey: ["sessionStorage", key],
    queryFn: () => sessionStorage.getItem(key),
  });

  const setItem = useMutation({
    mutationFn: (value: string) => {
      queryClient.setQueryData(["sessionStorage", key], value);
      sessionStorage.setItem(key, value);
      return Promise.resolve();
    },
  });

  return { ...q, setItem: setItem.mutate };
}
